<template>
  <div>
    <vs-card>
      <OrderDetails
        :isSidebarActive="orderDetailPopupActive"
        :data="paramDetail"
        @closeSidebar="toggleDataSidebar"
      />
      <vs-popup
        class="holamundo"
        :title="$t('PrintOrder')"
        :active.sync="popupOrdersPrint"
        fullscreen
        @closeSidebar="toggleDataSidebar"
      >
        <OrderPrint :data="paramDetail" />
      </vs-popup>
      <b-row align-h="end" class="mb-5">
        <b-col align-self="start">
          <b-row v-if="ROLE != 'Company'">
            <b-col cols="2" align-self="center">
              <b-form-group :label="'* ' + $t('Customer')" label-for="h-first-name">
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="customer"
                :options="customer_choices"
                size="small"
                label="name"
                autocomplete
                ref="selectElement"
                name="customer"
                v-validate="'required'"
              >
              </v-select>

              <span class="text-danger text-sm" v-show="errors.has('customer')">{{
                errors.first("customer")
              }}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0">
          <vs-button
            type="border"
            size="small"
            style="border-radius: 8px; font-size: small"
            @click="getPickingList"
            class="vs-con-loading__container"
            id="loading-picking"
            >{{ $t("PickingStatus") }}</vs-button
          >
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0">
          <vs-button
            type="border"
            size="small"
            color="warning"
            style="border-radius: 8px; font-size: small"
            @click="getPackingList"
            class="vs-con-loading__container"
            id="loading-packing"
            >{{ $t("PackingStatus") }}</vs-button
          >
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0">
          <vs-button
            type="border"
            size="small"
            color="success"
            style="border-radius: 8px; font-size: small"
            @click="getOrderList"
            class="vs-con-loading__container"
            id="loading-order"
            >{{ $t("ReadyForCargo") }}</vs-button
          >
        </b-col>
      </b-row>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table-status ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import i18nData from "../../i18n/i18nData";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import vSelect from "vue-select";
import twoInfoButtonsDynamic from "../CellRenderers/twoInfoButtonsDynamic.vue";
import OrderDetails from "./OrderDetails.vue";
import OrderPrint from "./OrderPrint.vue";
import TextViewCellRenderer from "../CellRenderers/TextViewCellRenderer.vue";
import moment from "moment";
export default {
  data() {
    return {
      popupOrdersPrint: false,
      orderDetailPopupActive: false,
      ROLE: this.$store.state.AppActiveUser.ROLE,
      customer: "",
      customer_choices: [],
      processList: [],
      paramDetail: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
      pinnedBottomRowData: null,
    };
  },
  computed: {
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
  },
  mounted() {
    this.$root.$on("orderDetail", (paramDetail) => {
      this.paramDetail = paramDetail;
      this.orderDetail();
    });
    this.$root.$on("printOrder", (paramDetail) => {
      this.paramDetail = paramDetail;
      this.popupOrdersPrint = true;
    });
  },
  beforeDestroy() {
    this.$root.$off("orderDetail");
    this.$root.$off("printOrder");
  },
  watch: {
    companydata(val) {
      this.getCustomerList();
      return val;
    },
  },
  components: {
    TextViewCellRenderer,
    OrderPrint,
    OrderDetails,
    twoInfoButtonsDynamic,
    vSelect,
    AgGridVue,
  },
  methods: {
    toggleDataSidebar(val = false) {
      this.orderDetailPopupActive = val;
      this.paramDetail = "";
    },
    orderDetail() {
      this.orderDetailPopupActive = true;
    },
    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.companydata;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
    createData(count, prefix) {
      var result = [];
      let newObj = {};
      newObj["TotalPrice"] = this.totalOrderPrice;

      result.push(newObj);
      return result;
    },
    onFirstDataRendered(params) {
      //   params.api.sizeColumnsToFit();
    },
    getOrderList() {
      const vs = this.$vs;
      let type = "material";
      vs.loading({
        container: `#loading-order`,
        type,
        scale: 0.5,
      });
      this.columns = [];
      let companyId = this.$store.state.AppActiveUser.companyid;
      if (this.ROLE != "Company") companyId = this.customer.value;
      this.$store
        .dispatch("order/listOrder", companyId)
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-order > .con-vs-loading");
            }, 1000);
            try {
              this.processList = JSON.parse(response.json);
              let columnList = Object.keys(this.processList[0]);
              this.columns.push({
                pinned: "left",
                width: 100,
                pinned: "left",
                cellRendererFramework: "twoInfoButtonsDynamic",
                cellRendererParams: {
                  detailMethodsOne: "orderDetail",
                  tooltipOne: "OrderDetail",
                  iconDetailOne: "uil:search",
                  iconColorOne: "#065a82",
                  detailMethodsTwo: "printOrder",
                  tooltipTwo: "PrintOrder",
                  iconDetailTwo: "material-symbols:print-outline",
                  iconColorTwo: "#ffcb77",
                },
              });
              columnList.forEach((val, index) => {
                if (
                  val == "OrderNumber" ||
                  val == "InvoiceName" ||
                  val == "InvoiceLastName" ||
                  val == "OrderCargoName" ||
                  val == "OrderCargoNumber" ||
                  val == "OrderSource"
                ) {
                  this.columns.push({
                    width: 100,
                    headerName: this.$t(val),
                    field: val,
                    pinned: "left",
                    filter: "agSetColumnFilter",
                    cellRendererFramework: "TextViewCellRenderer",
                  });
                } else if (
                  val.includes("Amount") == true ||
                  val.includes("Price") == true
                ) {
                  this.columns.push({
                    width: 100,
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                    valueFormatter: this.currencyFormatter,
                  });
                } else if (val.toString().includes("Date") == true) {
                  this.columns.push({
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                    valueFormatter: (params) => this.parseDate(params.data[val]),
                  });
                } else if (
                  val != "Items" &&
                  val != "id" &&
                  val != "packageHistories" &&
                  val != "timeSlotId" &&
                  val != "scheduledDeliveryStoreId" &&
                  val != "originShipmentDate" &&
                  val != "lastModifiedDate" &&
                  val != "commercial" &&
                  val != "shipmentAddress" &&
                  val != "invoiceAddress" &&
                  val.includes("Id") == false
                )
                  this.columns.push({
                    width: 100,
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                    cellRendererFramework: "TextViewCellRenderer",
                  });
              });
              this.pinnedBottomRowData = this.createData(1, "Bottom");
            } catch (error) {
              console.log(error);
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-order > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-order > .con-vs-loading");
          }, 1000);
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getPackingList() {
      const vs = this.$vs;
      this.columns = [];
      let type = "material";
      vs.loading({
        container: `#loading-packing`,
        type,
        scale: 0.5,
      });
      let companyId = this.$store.state.AppActiveUser.companyid;
      if (this.ROLE != "Company") companyId = this.customer.value;
      let args = {
        companyId: companyId,
        collectionIsDone: true,
      };
      this.$store
        .dispatch("order/listOrderCollectHead", args)
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-packing > .con-vs-loading");
            }, 1000);
            try {
              this.processList = JSON.parse(response.json);
              let columnList = Object.keys(this.processList[0]);
              columnList.forEach((val, index) => {
                if (val == "CompanyName") {
                  this.columns.push({
                    pinned: "left",
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                  });
                } else if (val.toString().includes("Date") == true)
                  this.columnsProcess.push({
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                    valueFormatter: (params) => this.parseDate(params.data[val]),
                    editable: true,
                  });
                else if (
                  val.toString().includes("Id") == false &&
                  val.toString().includes("CollectionDone") == false &&
                  val.toString().includes("CollectionPackageDone") == false
                ) {
                  this.columns.push({
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                  });
                }
              });
            } catch (error) {
              console.log(error);
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-packing > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          setTimeout(() => {
            vs.loading.close("#loading-packing > .con-vs-loading");
          }, 1000);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    getPickingList() {
      const vs = this.$vs;
      this.columns = [];
      let type = "material";
      vs.loading({
        container: `#loading-picking`,
        type,
        scale: 0.5,
      });
      let companyId = this.$store.state.AppActiveUser.companyid;
      if (this.ROLE != "Company") companyId = this.customer.value;
      let args = {
        companyId: companyId,
        collectionIsDone: false,
      };
      this.$store
        .dispatch("order/listOrderCollectHead", args)
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-picking > .con-vs-loading");
            }, 1000);
            try {
              this.processList = JSON.parse(response.json);
              let columnList = Object.keys(this.processList[0]);
              columnList.forEach((val, index) => {
                if (val == "CompanyName") {
                  this.columns.push({
                    pinned: "left",
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                  });
                } else if (val.toString().includes("Date") == true)
                  this.columnsProcess.push({
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                    valueFormatter: (params) => this.parseDate(params.data[val]),
                    editable: true,
                  });
                else if (val.toString().includes("Id") == false) {
                  this.columns.push({
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                  });
                }
              });
            } catch (error) {
              console.log(error);
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-picking > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-picking > .con-vs-loading");
          }, 1000);
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
  },
  created() {
    if (this.ROLE != "Company") this.getCustomerList();
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table-status {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 140px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
